<div class="input-group">
	<input class="form-control" readonly placeholder="yyyy-mm-dd" (click)="theDatePicker.toggle()" [(ngModel)]="myValue" ngbDatepicker #theDatePicker="ngbDatepicker" [minDate]="{year: 2000, month: 1, day: 1}"
		[maxDate]="{year: 2040, month: 12, day: 31}" [markDisabled]="isDisabled" firstDayOfWeek="7" />
	<div class="input-group-append">
		<button class="btn btn-info icon-calendar" (click)="theDatePicker.toggle()" type="button"></button>
	</div>
</div>